import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'antd'
import OwnersMultiSelect from '../forms/OwnersMultiSelect';
import { EventOwner } from '../../pages/admin/event_owners/index.page';
import { Event } from '@/types/events';

interface AssignOwnersModalProps {
  visible: boolean;
  onCancel: () => void;
  event: Event | null;
  eventOwners: EventOwner[];
  initialSelectedOwners: string[];
  onAssign: (eventId: string, ownerIds: string[]) => void;
}

const AssignOwnersModal: React.FC<AssignOwnersModalProps> = ({
  visible,
  onCancel,
  event,
  eventOwners,
  initialSelectedOwners,
  onAssign,
}) => {
  const [selectedOwnerIds, setSelectedOwnerIds] = useState<string[]>(
    initialSelectedOwners.map((id) => id.toString())
  );

  // Update selected owners when initialSelectedOwners changes or modal becomes visible
  useEffect(() => {
    if (visible) {
      setSelectedOwnerIds(initialSelectedOwners.map((id) => id.toString()));
    }
  }, [visible, initialSelectedOwners]);

  const handleAssign = () => {
    if (event?.id) {
      onAssign(event.id, selectedOwnerIds);
    }
  };

  return (
    <Modal
      title="Assign Event Owner(s)"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="assign"
          type="primary"
          className="bg-blue-800 hover:bg-blue-700"
          onClick={handleAssign}
        >
          Assign
        </Button>
      ]}
      width={500}
    >
      <div className="mt-6">
        <OwnersMultiSelect
          eventOwners={eventOwners}
          selectedOwnerIds={selectedOwnerIds}
          onChange={setSelectedOwnerIds}
        />
      </div>
    </Modal>
  );
};
export default AssignOwnersModal;
